export const DIALOG_SHOW = 'DIALOG_SHOW'
export const DIALOG_HIDE = 'DIALOG_HIDE'
// 创建用户createUser弹窗的显示与隐藏
export const CREATE_USER_SHOW = 'CREATE_USER_SHOW'
export const CREATE_USER_HIDE = 'CREATE_USER_HIDE'
// 用户信息user弹窗的显示与隐藏
export const USER_SHOW = 'USER_SHOW'
export const USER_HIDE = 'USER_HIDE'
// 用户列表userList弹窗的显示与隐藏
export const USER_LIST_SHOW = 'USER_LIST_SHOW'
export const USER_LIST_HIDE = 'USER_LIST_HIDE'
// 通用列表listDialog弹窗的显示与隐藏
export const LIST_DIALOG_SHOW = 'LIST_DIALOG_SHOW'
export const LIST_DIALOG_HIDE = 'LIST_DIALOG_HIDE'
// 创建用户组createGroup弹窗的显示与隐藏
export const CREATE_GROUP_SHOW = 'CREATE_GROUP_SHOW'
export const CREATE_GROUP_HIDE = 'CREATE_GROUP_HIDE'
// 用户组信息group弹窗的显示与隐藏
export const GROUP_SHOW = 'GROUP_SHOW'
export const GROUP_HIDE = 'GROUP_HIDE'
// 授权authority弹窗的显示与隐藏
export const AUTHORITY_SHOW = 'AUTHORITY_SHOW'
export const AUTHORITY_HIDE = 'AUTHORITY_HIDE'
// 通用选择select-dialog弹窗的显示与隐藏
export const SELECT_DIALOG_SHOW = 'SELECT_DIALOG_SHOW'
export const SELECT_DIALOG_HIDE = 'SELECT_DIALOG_HIDE'
// 通用选择类型selectType-dialog弹窗的显示与隐藏
export const SELECT_TYPE_DIALOG_SHOW = 'SELECT_TYPE_DIALOG_SHOW'
export const SELECT_TYPE_DIALOG_HIDE = 'SELECT_TYPE_DIALOG_HIDE'

// properties 左侧树右键属性

export const PROPERTIES_DIALOG_SHOW = 'PROPERTIES_DIALOG_SHOW'
export const PROPERTIES_DIALOG_HIDE = 'PROPERTIES_DIALOG_HIDE'

// 动态图对象属性

export const ONLINECHART_PROPERTIES_DIALOG_SHOW =
  'ONLINECHART_PROPERTIES_DIALOG_SHOW'
export const ONLINECHART_PROPERTIES_DIALOG_HIDE =
  'ONLINECHART_PROPERTIES_DIALOG_HIDE'

// 动态图-曲线趋势记录对象属性

export const ONLINECHART_PROPERTIES_TREND_SHOW =
  'ONLINECHART_PROPERTIES_TREND_SHOW'
export const ONLINECHART_PROPERTIES_TREND_HIDE =
  'ONLINECHART_PROPERTIES_TREND_HIDE'

// 图形化对象属性

export const GRAPHI_CALLY_SHOW =
  'GRAPHI_CALLY_SHOW'
export const GRAPHI_CALLY_HIDE =
  'GRAPHI_CALLY_HIDE'

// 记事本

export const NOTE_BOOK_SHOW =
  'NOTE_BOOK_SHOW'
export const NOTE_BOOK_HIDE =
  'NOTE_BOOK_HIDE'

// 数据接口

export const DATA_INTERFACE_SHOW =
  'DATA_INTERFACE_SHOW'
export const DATA_INTERFACE_HIDE =
  'DATA_INTERFACE_HIDE'

// topic

export const TOPIC_SHOW =
  'TOPIC_SHOW'
export const TOPIC_HIDE =
  'TOPIC_HIDE'

// DOOR

export const DOOR_SHOW =
  'DOOR_SHOW'
export const DOOR_HIDE =
  'DOOR_HIDE'

// TREND

export const TREND_LOGS_SHOW =
  'TREND_LOGS_SHOW'
export const TREND_LOGS_HIDE =
  'TREND_LOGS_HIDE'

// USERS

export const USERS_SHOW =
  'USERS_SHOW'
export const USERS_HIDE =
  'USERS_HIDE'


// 计算工具

export const COUNT_BOOK_SHOW =
  'COUNT_BOOK_SHOW'
export const COUNT_BOOK_HIDE =
  'COUNT_BOOK_HIDE'

// 趋势日志

export const TREND_JOURNAL_SHOW =
  'TREND_JOURNAL_SHOW'
export const TREND_JOURNAL_HIDE =
  'TREND_JOURNAL_HIDE'

// 趋势日志
export const TREND_JOURNAL_EXPRESS_SHOW =
  'TREND_JOURNAL_EXPRESS_SHOW'
export const TREND_JOURNAL_EXPRESS_HIDE =
  'TREND_JOURNAL_EXPRESS_HIDE'

// 报警接收者对象属性

export const ALARMCHART_PROPERTIES_DIALOG_SHOW =
  'ALARMCHART_PROPERTIES_DIALOG_SHOW'
export const ALARMCHART_PROPERTIES_DIALOG_HIDE =
  'ALARMCHART_PROPERTIES_DIALOG_HIDE'

// change-of-state对象属性

export const CHANGE_OF_STATE_SHOW = 'CHANGE_OF_STATE_SHOW'
export const CHANGE_OF_STATE_HIDE = 'CHANGE_OF_STATE_HIDE'

// alarmControl对象属性

export const ALARM_CONTROL_SHOW = 'ALARM_CONTROL_SHOW'
export const ALARM_CONTROL_HIDE = 'ALARM_CONTROL_HIDE'

// 报警用户组group-alarm对象属性

export const GROUP_ALARM_SHOW = 'GROUP_ALARM_SHOW'
export const GROUP_ALARM_HIDE = 'GROUP_ALARM_HIDE'

// 设备对象
export const DEVICE_DIALOG_SHOW = 'DEVICE_DIALOG_SHOW'
export const DEVICE_DIALOG_HIDE = 'DEVICE_DIALOG_HIDE'

// 程序的下载
export const ORDER_DIALOG_SHOW = 'ORDER_DIALOG_SHOW'
export const ORDER_DIALOG_HIDE = 'ORDER_DIALOG_HIDE'

// 设备列表对象

export const DEVICE_LIST_DIALOG_SHOW = 'DEVICE_LIST_DIALOG_SHOW'
export const DEVICE_LIST_DIALOG_HIDE = 'DEVICE_LIST_DIALOG_HIDE'

// 刷新树属性
export const NEED_RELOAD_TREE = 'NEED_RELOAD_TREE'
export const DONOT_NEED_RELOAD_TREE = 'DONOT_NEED_RELOAD_TREE'

// 点位控制
export const POINT_SHOW = 'POINT_SHOW'
export const POINT_HIDE = 'POINT_HIDE'

// 添加folder类节点
export const FOLDER_SHOW = 'FOLDER_SHOW'
export const FOLDER_HIDE = 'FOLDER_HIDE'

// 添加folder工具类节点
export const FOLDER_DESGIN_SHOW = 'FOLDER_DESGIN_SHOW'
export const FOLDER_DESGIN_HIDE = 'FOLDER_DESGIN_HIDE'

// 时间表控制
export const TIME_CHART_SHOW = 'TIME_CHART_SHOW'
export const TIME_CHART_HIDE = 'TIME_CHART_HIDE'

// 时间表批量控制
export const TIME_CHART_BATCH_SHOW = 'TIME_CHART_BATCH_SHOW'
export const TIME_CHART_BATCH_HIDE = 'TIME_CHART_BATCH_HIDE'

// 值时间表
export const TIME_CHART_VALUE_SHOW = 'TIME_CHART_VALUE_SHOW'
export const TIME_CHART_VALUE_HIDE = 'TIME_CHART_VALUE_HIDE'

// 能耗资源创建
export const ENERGY_DIALOG_SHOW = 'ENERGY_DIALOG_SHOW'
export const ENERGY_DIALOG_HIDE = 'ENERGY_DIALOG_HIDE'

// 能耗资源创建
export const ENERGY_BAR_SHOW = 'ENERGY_BAR_SHOW'
export const ENERGY_BAR_HIDE = 'ENERGY_BAR_HIDE'

// 能耗批量统计
export const ENERGY_STATISTICS_SHOW = 'ENERGY_STATISTICS_SHOW'
export const ENERGY_STATISTICS_HIDE = 'ENERGY_STATISTICS_HIDE'

// 盘管检查
export const COIL_DIALOG_SHOW = 'COIL_DIALOG_SHOW'
export const COIL_DIALOG_HIDE = 'COIL_DIALOG_HIDE'

// 创建规则
export const RULE_DIALOG_SHOW = 'RULE_DIALOG_SHOW'
export const RULE_DIALOG_HIDE = 'RULE_DIALOG_HIDE'

// 创建方波
export const SQUARE_DIALOG_SHOW = 'SQUARE_DIALOG_SHOW'
export const SQUARE_DIALOG_HIDE = 'SQUARE_DIALOG_HIDE'


// 假期时间表
export const HOLIDAY_SHOW = 'HOLIDAY_SHOW'
export const HOLIDAY_HIDE = 'HOLIDAY_HIDE'


// 点位弹窗

export const OPEN_POINT_DIALOG = 'OPEN_POINT_DIALOG'
// 搜索界面控制
export const SEARCH_DIALOG_SHOW = 'SEARCH_DIALOG_SHOW'
export const SEARCH_DIALOG_HIDE = 'SEARCH_DIALOG_HIDE'

// 对象传输界面控制
export const OBJECT_TRANSFER_SHOW = 'OBJECT_TRANSFER_SHOW'
export const OBJECT_TRANSFER_HIDE = 'OBJECT_TRANSFER_HIDE'

// 时间事件对象界面控制
export const TIME_EVENT_OBJECT_SHOW = 'TIME_EVENT_OBJECT_SHOW'
export const TIME_EVENT_OBJECT_HIDE = 'TIME_EVENT_OBJECT_HIDE'

// 时间事件列表界面控制
export const TIME_EVENT_LIST_SHOW = 'TIME_EVENT_LIST_SHOW'
export const TIME_EVENT_LIST_HIDE = 'TIME_EVENT_LIST_HIDE'

// 统计模块界面控制
export const STATISTICS_MODULE_SHOW = 'STATISTICS_MODULE_SHOW'
export const STATISTICS_MODULE_HIDE = 'STATISTICS_MODULE_HIDE'

// 标签管理界面控制（statisticModule）
export const LABEL_MANAGE_SHOW = 'LABEL_MANAGE_SHOW'
export const LABEL_MANAGE_HIDE = 'LABEL_MANAGE_HIDE'

// 标签管理界面控制（EHI）
export const EHI_LABEL_MANAGE_SHOW = 'EHI_LABEL_MANAGE_SHOW'
export const EHI_LABEL_MANAGE_HIDE = 'EHI_LABEL_MANAGE_HIDE'

// 环境健康指数界面控制
export const EHI_SHOW = 'EHI_SHOW'
export const EHI_HIDE = 'EHI_HIDE'

// 海康摄像头界面控制
export const HKVIDEO_SHOW = 'HKVIDEO_SHOW'
export const HKVIDEO_HIDE = 'HKVIDEO_HIDE'

// 值计算功能
export const VALUE_CALCULATION_SHOW = 'VALUE_CALCULATION_SHOW'
export const VALUE_CALCULATION_HIDE = 'VALUE_CALCULATION_HIDE'


// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js